<li class="nav-item" #navItem
    *ngIf="adminFeaturesEnabled && (rightsGranted || demoModeEnabled)" id="{{model.id}}">
  <div class="disabled-overlay cursor-pointer" *ngIf="!rightsGranted" (click)="showDisabledDialog()"></div>
  <a class="nav-link layout-nav-link" [uiSref]="model.destination">
    <i class="icomoon {{model.icon}} align-middle"></i>
    {{model.titleKey | translate}}
  </a>
</li>
